import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import { ResetPasswordModel } from './reset.model';
import { BaseService } from '../../core/base.service';


@Injectable()
export class ResetPasswordService extends BaseService {

    private headers = new Headers({'Content-Type': 'application/json;charset=UTF-8'});

    constructor(private http: Http) { 
        super();
    }

    requestResetPassword(resetPasswordModel : ResetPasswordModel) : Observable<any>{
        
        return this.http.post(
            this.urls.requestResetPassword,
            JSON.stringify(resetPasswordModel),
            {headers: this.headers})
            .catch(err => this.handleErrorAsPromise(err));
    }

     updatePassword(resetPasswordModel : ResetPasswordModel) : Observable<any>{
        
        return this.http.post(
            this.urls.updatePassword,
            JSON.stringify(resetPasswordModel),
            {headers: this.headers})
            .catch(err => this.handleErrorAsPromise(err));
    }
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/reset/reset.service.ts